<div
  class="l-modal01__contents l-modal01__contents--w384 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="modalTitle"
>
  <!-- クーポンコード入力モーダル　ヘッダー -->
  <div class="l-modal01__header js-modal-head">
    <div class="p-modal-head01">
      <h1 id="modalTitle" class="p-modal-head01__title" [innerHTML]="'label.promotionCode' | staticMsg"></h1>
      <button id="p-use-coupons-header-button" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <!-- クーポンコード入力モーダル　ボディ -->
  <div class="l-modal01__body js-modal-body">
    <div class="p-modal-use-coupon">
      <div class="p-modal-use-coupon__body">
        <form [formGroup]="couponFormGroup">
          <asw-input
            type="text"
            id="use-coupons-input-1"
            label="{{ 'label.promotionCode' | staticMsg }}"
            name="use-coupons-input-1"
            class="c-form-element-input__input-item"
            formControlName="couponCode"
            placeholder="{{ 'placeholder.Couponcode' | staticMsg }}"
            aria-invalid="false"
            [attr.aria-label]="'reader.sampleDisco' | staticMsg"
          ></asw-input>
        </form>
      </div>
    </div>
  </div>
  <!-- クーポンコード入力モーダル　フッター -->
  <div class="l-modal01__footer l-modal01__footer--not-bt js-modal-footer">
    <div class="p-modal-foot02">
      <button
        id="use-coupons-button-2"
        class="c-btn-tertiary c-btn-tertiary--s c-btn-tertiary--min-w100"
        aswThrottleClick
        (click)="clickCancelPromotionCode()"
        [throttleTime]="500"
      >
        <span class="c-btn-tertiary__text" [innerHTML]="'button.close' | staticMsg"></span>
      </button>
      <button
        id="use-coupons-button-3"
        class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
        aswThrottleClick
        (click)="clickApplyPromotionCode()"
        [throttleTime]="500"
      >
        <span class="c-btn-primary__text" [innerHTML]="'button.promoNext' | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
